import { Component, OnInit } from "@angular/core";
import { CommonService } from "../../../../services/common.service";
import { CartService } from "../../../../services/cart.service";
import { ReservationService } from "../../../../services/reservation.service";
import { AuthService } from "../../../../services/auth.service";

@Component({
  selector: "page-reserve-seat-map-plan-2",
  templateUrl: "./plan-2.component.html",
})
export class PageReserveSeatMapPlan2Component implements OnInit {
  public _: any;
  public $: any;
  public moment: any;

  public cartData: any;
  public passengerList: any;
  public reservationData: any;
  public seatMapData: any;
  public seatMap: any;
  public seatMapSelected: boolean = null;

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  constructor(
    public commonService: CommonService,
    public cartService: CartService,
    public reservationService: ReservationService,
    public authService: AuthService
  ) {
    let self = this;
    this._ = this.commonService.getLodash();
    this.$ = this.commonService.getJQuery();
    this.moment = this.commonService.getMoment();
  }

  async ngOnInit() {
    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* GET CART & RESERVATION DATA */
    this.cartData = this.cartService.getCartData();
    this.reservationData = this.reservationService.getReservationData();

    /* CHECK IF HAS DATA */
    if (this._.isEmpty(this.cartData) || this._.isEmpty(this.reservationData)) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pagePlanList
      );
    }

    /* GET PASSENGER LIST */
    this.passengerList = await this.reservationService.getPassengerData();

    /* GET SEAT MAP DATA */
    this.seatMapData = await this.reservationService.getSeatMapData({
      plan_code: this.cartData[1].plan.plan_code,
      dpt_ymd: this.moment(this.cartData[1].targetDay).format("YYYYMMDD"),
    });
    /* APPEND DATA */
    this.$("#seatMapTable").empty().html(this.seatMapData.html);

    /* INIT seatMap */
    this.initSeatMap();

    /* EXECUTE INLINE JS */
    this.inlineJS();

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  initSeatMap() {
    /* DISCARD PLAN 1 SEATS */
    for (let i = 0; i < this.passengerList[0].list.length; i++) {
      // this.$(`#${this.reservationData[`1_p_seat_number_${i + 1}`]}\\[1\\]`)
      //   .closest("td")
      //   .empty()
      //   .html("<br><mark>【1】<br>指定済み</mark>");
    }
    /* END */

    this.seatMap = {};

    for (let i = 0; i < this.passengerList[1].list.length; i++) {
      let seatNumber = this.reservationData[`2_p_seat_number_${i + 1}`];
      let jQueryInput = this.$(`#${seatNumber}\\[1\\]`);

      if (seatNumber && jQueryInput.length !== 0) {
        this.seatMap[`seat_${i}`] = seatNumber;
        this.seatMapSelected = true;
        jQueryInput.prop("checked", true);
      } else {
        this.seatMap[`seat_${i}`] = null;
      }
    }

    if (this.reservationData[`2_p_seat_selected`] === 0) {
      this.seatMapSelected = false;
    }
  }

  toggleSeat(seatID: any = "") {
    /* UNCHECK */
    for (let i = 0; i < this.passengerList[1].list.length; i++) {
      if (this.seatMap[`seat_${i}`] == seatID) {
        this.seatMap[`seat_${i}`] = null;
        this.reservationData[`2_p_seat_price_${i + 1}`] = null;
        return;
      }
    }
    /* CHECK */
    for (let i = 0; i < this.passengerList[1].list.length; i++) {
      if (this.seatMap[`seat_${i}`] == null) {
        this.seatMap[`seat_${i}`] = seatID;
        /* SAVE PRICES */
        for (let seat of this.seatMapData.seat_price_list) {
          if (seat.seat_number == seatID) {
            this.reservationData[`2_p_seat_price_${i + 1}`] = seat.price;
            break;
          }
        }
        /* END */

        return;
      }
    }
  }

  validateEmptySeats() {
    let hasError = false;

    if (this.tempData.isSubmitted) {
      if (!this.tempData.seatErrors) {
        this.tempData.seatErrors = {};
      }

      for (let i = 0; i < this.passengerList[1].list.length; i++) {
        if (this.seatMap[`seat_${i}`] == null) {
          this.tempData.seatErrors[`seat_${i}`] = true;
          hasError = true;
        } else {
          delete this.tempData.seatErrors[`seat_${i}`];
        }
      }
    }

    return hasError;
  }

  onSubmit() {
    if (this.seatMapSelected != null) {
      this.tempData.isSubmitted = true;

      if (this.seatMapSelected) {
        /* CHOOSE SEATS */

        /* VALIDATE DATA */
        if (this.validateEmptySeats()) {
          /* SCROLL TO THE FIRST ERROR FORM */
          if (this.$(".errorMsg:visible").length !== 0) {
            this.$("html, body").animate(
              {
                scrollTop:
                  this.$(".errorMsg:visible").first().offset().top - 90,
              },
              200
            );
          }
          return false;
        }

        /* SAVE DATA */
        for (let i = 0; i < this.passengerList[1].list.length; i++) {
          this.reservationData[`2_p_seat_number_${i + 1}`] =
            this.seatMap[`seat_${i}`];
        }

        /* SAVE STATE */
        this.reservationData[`2_p_seat_selected`] = 1;
      } else {
        /* EMPTY SEATS */

        for (let i = 0; i < this.passengerList[1].list.length; i++) {
          this.seatMap[`seat_${i}`] = null;
          delete this.tempData.seatErrors;
          delete this.reservationData[`2_p_seat_number_${i + 1}`];
          delete this.reservationData[`2_p_seat_price_${i + 1}`];
        }

        /* SAVE STATE */
        this.reservationData[`2_p_seat_selected`] = 0;
      }

      /* SAVE RESERVATION DATA */
      this.reservationService.saveReservationData(this.reservationData);

      if (this.reservationData.goToInsurancePage) {
        this.commonService.redirectToRoute(
          this.commonService.routePaths.pageReserveInsurance
        );
      } else {
        this.commonService.redirectToRoute(
          this.commonService.routePaths.pageReservePayment
        );
      }
    }
  }

  inlineJS() {
    let self = this;

    self.$(function () {
      /* CLEAN SAKURA RAW DATA */
      self.$(".seat-data td").removeAttr("height");

      self.$("font").each(function () {
        self
          .$(this)
          .replaceWith(
            self.$(
              '<span class="seat-heading">' + self.$(this).html() + "</span>"
            )
          );
      });
      /* END */

      /* CHOOSE SEAT */
      self.$(`#seatMapTable input[type="checkbox"]`).click(function () {
        if (
          self.$(`#seatMapTable input[type="checkbox"]:checked`).length - 1 !==
          self.passengerList[1].list.length
        ) {
          self.toggleSeat(self.$(this).val());
          self.validateEmptySeats();
        } else {
          return false;
        }
      });
    });
  }
}
